//import AdminRoleConfig from './admin-role/AdminRoleConfig';
import GuestRoleConfig from './guest-role/GuestRoleConfig';
//import StaffRoleConfig from './staff-role/StaffRoleConfig';

//const authRoleConfigs = [AdminRoleConfig, StaffRoleConfig, GuestRoleConfig];
const authRoleConfigs = [GuestRoleConfig];

export default authRoleConfigs;